import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { Icon } from "@vds/icons";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: ${(props) => props.maxHeight || "90vh"};
  width: ${(props) => props.width || "100vw"};
  max-width: ${(props) => props.maxWidth || "1400px"};
  height: ${(props) => props.height || "auto"};
  margin-top: ${(props) => props.marginTop || "none"};
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif;
`;

const ModalContent = styled.div`
  padding: 0 1rem 4rem;
  overflow-y: auto;
  flex-grow: 1;
`;

const CloseButton = styled.div`
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomModal = ({ isOpen, onClose, title, children, width, maxWidth, height, maxHeight, marginTop }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
      }, 100);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContainer
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        width={width}
        maxWidth={maxWidth}
        height={height}
        maxHeight={maxHeight}
        marginTop={marginTop}
      >
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onClose}>
            <Icon name="close" aria-label="close" alt="close-icon" size="medium" color="#000000" />
          </CloseButton>
        </ModalHeader>
        <ModalContent>{children}</ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default CustomModal;
